import React, {useState} from "react";
import {FormControl, FormLabel, Unstable_Grid2 as Grid} from "@mui/material";
import {useFormContext} from "react-hook-form";

export interface GridRadioButtonData {
    [key: string]: any;
    id: number;
    label: string;
}

interface Props {
    buttons: GridRadioButtonData[],
    radioGroupId: string,
    onClick: (data: GridRadioButtonData) => void
}

const GridRadioButtons: React.FC<Props> = (props) => {

    const [, setForceRender] = useState(0);

    const {
        buttons,
        onClick,
        radioGroupId
    } = props;

    const {
        register,
        getValues
    } = useFormContext();

    if(!buttons || !buttons.length)
    {
        return <></>;
    }

    const internalOnChange = (button: GridRadioButtonData) => {
        onClick(button);
        setForceRender(prev => prev + 1);
    };


    return <FormControl fullWidth>
            <Grid container spacing={2}>
            {
                buttons.map((button, index) => <Grid key={index} xs={6}>
                            <FormLabel
                                className={`multi-choice-radio ${button.id == getValues(radioGroupId) ? "multi-choice-radio-active" : ""}`}
                            >
                                <input
                                    style={{"opacity": 0, height: 0, width: 0, position: "absolute"}}
                                    type={"radio"}
                                    value={button.id}
                                    {...register(radioGroupId, {
                                        onChange: () => internalOnChange(button)
                                    })}
                                />
                                {button.label}
                            </FormLabel>
                    </Grid>)
            }
        </Grid>
    </FormControl>;
};

export { GridRadioButtons };